export interface MicSession {
  stop: () => Promise<Blob>;
}

export async function startMicSession(): Promise<MicSession> {
  const stream = await navigator.mediaDevices.getUserMedia({
    audio: true,
    video: false,
  });

  try {
    const ctx = new AudioContext();
    const gain = ctx.createGain();
    gain.gain.value = 2;
    const dest = ctx.createMediaStreamDestination();
    ctx.createMediaStreamSource(stream).connect(gain);
    gain.connect(dest);

    const recorder = new MediaRecorder(dest.stream, {
      mimeType: 'audio/webm;codecs="opus"',
    });

    const blob = new Promise<Blob>((resolve) => {
      recorder.addEventListener('dataavailable', (e) => resolve(e.data), {
        once: true,
      });
    });
    recorder.addEventListener(
      'stop',
      () => {
        stream.getTracks().forEach((track) => track.stop());
        if (ctx.state !== 'closed') void ctx.close();
      },
      { once: true }
    );
    recorder.start();

    return {
      stop: () => {
        if (recorder.state !== 'inactive') recorder.stop();
        return blob;
      },
    };
  } catch (e) {
    stream.getTracks().forEach((track) => track.stop());
    throw e;
  }
}
